export enum IntegrationEnum {
    Aura = '00000000-0000-0000-0000-000000000057',
    BrainTree = '00000000-0000-0000-0000-000000000043',
    Docusign = '00000000-0000-0000-0000-000000000025',
    Magnum = '00000000-0000-0000-0000-000000000037',
    IntelliScript = '00000000-0000-0000-0000-000000000021',
    Irix = '00000000-0000-0000-0000-000000000008',
    PrimorisEmbedded = '00000000-0000-0000-0000-000000000056',
    PortalOne = '00000000-0000-0000-0000-000000000061',
    Stripe = '00000000-0000-0000-0000-000000000077',
    TrustCommerce = '00000000-0000-0000-0000-000000000048',
    LexistNexisLifeDataPrefill = '00000000-0000-0000-0000-000000000089',
    DigitalOwl = '00000000-0000-0000-0000-000000000094',
    ParamedsAps = '00000000-0000-0000-0000-000000000084',
    Mras = '00000000-0000-0000-0000-000000000101',
    Tranzpay = '00000000-0000-0000-0000-000000000113',
    TranzpayTrinity = '00000000-0000-0000-0000-000000005113',
    Input1 = '00000000-0000-0000-0000-000000000120',
    HealthIntelligence = '00000000-0000-0000-0000-000000000115',
    Hannover = '00000000-0000-0000-0000-000000000122',
    Illustrata = '00000000-0000-0000-0000-000000000123',
    Apps = '00000000-0000-0000-0000-000000000125'
}
